<template>
  <div class="layout-user-wx-bind">
    <slot :show="show"></slot>
    <DataGridDialog title="微信绑定"
                    width="450px"
                    :visible.sync="visible"
                    custom-class="layout-user-wx-bind-popover"
                    @open="handleOpen"
                    @closed="handleClosed">
      <div class="wx-bind-wrap"
           v-loading="loading"
           element-loading-text="二维码加载中...">
        <div class="title">扫码绑定微信</div>
        <div class="qr-code">
          <img v-if="ticket"
               alt="二维码"
               :src="`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket.data}`"/>
        </div>
        <div class="expire">
          <template v-if="loading">
            <span>加载中...</span>
          </template>
          <template v-else>
            <span>有效期：</span>
            <span v-if="isExpire">
              <span class="is-danger">已过期</span>
              <el-button size="mini"
                         type="text"
                         icon="el-icon-refresh"
                         @click="getQrCode">刷新</el-button>
            </span>
            <span v-else>{{expire | time}}</span>
          </template>
        </div>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../elements/grid/DataGridDialog'
export default {
  name: 'WxBind',
  components: {
    DataGridDialog
  },
  data () {
    return {
      visible: false,
      loading: false,
      ticket: null,
      expire: null
    }
  },
  computed: {
    isExpire () {
      return typeof this.expire === 'number' && this.expire <= 0
    }
  },
  filters: {
    time (value) {
      if (typeof value === 'number') {
        let m = Math.floor(value / 60)
        let s = value % 60
        let time = []
        if (m > 0) {
          time.push(`${m}分`)
        }
        time.push(`${s}秒`)
        return time.join('')
      } else {
        return '--'
      }
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    getQrCode () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/security/qrCode',
        method: 'post',
        disableErrorPage: true
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.ticket = response.data.ticket || {}
              this.$nextTick(() => this.checkLogin())
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败')
      }).finally(() => {
        this.loading = false
      })
    },
    checkLogin () {
      if (this.checkTimer) {
        clearTimeout(this.checkTimer)
      }
      if (this.isExpire) {
        return
      }
      this.$ajax({
        url: '/workspace/manager/portal/security/checkScan',
        method: 'post',
        disableErrorPage: true
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.hide()
              this.$nextTick(() => {
                this.$emit('bind-success')
              })
              break
            }
            default: {
              this.checkTimer = setTimeout(() => this.checkLogin(), 1000)
              break
            }
          }
        }
      }, () => {
        this.checkTimer = setTimeout(() => this.checkLogin(), 1000)
      })
    },
    handleOpen () {
      this.getQrCode()
    },
    handleClosed () {
      if (this.checkTimer) {
        clearTimeout(this.checkTimer)
      }
      if (this.countTimer) {
        clearInterval(this.countTimer)
      }
    }
  },
  beforeDestroy () {
    if (this.checkTimer) {
      clearTimeout(this.checkTimer)
    }
    if (this.countTimer) {
      clearInterval(this.countTimer)
    }
  },
  watch: {
    ticket (val) {
      if (val) {
        this.expire = val.expire
        if (this.countTimer) {
          clearInterval(this.countTimer)
        }
        this.countTimer = setInterval(() => {
          this.expire--
          if (this.expire <= 0) {
            clearInterval(this.countTimer)
          }
        }, 1000)
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../styles/color";
  .layout-user-wx-bind {
    display: inline-block;
  }
  .layout-user-wx-bind-popover {
    .wx-bind-wrap {
      padding: 15px 15px 30px;
      & > .title {
        color: #909399;
        font-size: 12px;
        text-align: center;
      }
      & > .qr-code {
        margin-top: 10px;
        height: 240px;
        text-align: center;
        img {
          width: 240px;
          height: 100%;
          border: 1px solid $set-info-color;
        }
      }
      & > .expire {
        margin-top: 10px;
        color: #606266;
        font-size: 12px;
        text-align: center;
        .is-danger {
          color: $set-danger-color;
        }
        .el-button {
          padding: 0 5px;
        }
      }
    }
  }
</style>
